import { createSelector } from 'reselect';

// Config
import routeConstants from '@constants/routeConstants';
import { getSessionHandoverFailedSelector, getSessionHandoverCompleteSelector } from '@redux/reducers/bff/bffSelector';
import {
  getAuth0AccessTokenSelector,
  getRequestAccessTokenSelector,
} from '@redux/reducers/mobileApps/mobileAppsSelector';
import { getLoginPageCompleteSelector } from '@redux/reducers/login/loginSelector';
import { getRouterLocationPathname } from '@redux/reducers/router/routerSelector';

const sessionManagerSelector = createSelector(
  [
    getSessionHandoverFailedSelector,
    getSessionHandoverCompleteSelector,
    getLoginPageCompleteSelector,
    getRouterLocationPathname,
    getAuth0AccessTokenSelector,
    getRequestAccessTokenSelector,
  ],
  (
    sessionHandoverComplete,
    sessionHandoverFailed,
    getLoginPageComplete,
    pathname,
    auth0AccessToken,
    requestAccessToken,
  ) => ({
    sessionHandoverComplete,
    sessionHandoverFailed,
    getLoginPageComplete,
    isAppsGuestHandover: routeConstants.APPS_GUEST_HANDOVER === pathname,
    isAppsAuthenticatedHandover: routeConstants.APPS_AUTHENTICATED_HANDOVER === pathname,
    auth0AccessToken,
    requestAccessToken,
  }),
);

export default sessionManagerSelector;
